import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Alert, AlertService, AlertType, LoggingService } from '@app-core';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-alert',
    imports: [NgbAlertModule],
    templateUrl: './alert.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './alert.component.scss',
})
export class AlertComponent implements OnInit, OnDestroy {
    alerts: Array<Alert> = [];
    alertSubcription: Subscription = new Subscription();
    routerSubscription: Subscription = new Subscription();

    constructor(
        private readonly alertService: AlertService,
        private readonly router: Router,
    ) {}

    ngOnInit(): void {
        this.alertSubcription = this.alertService.onAlert().subscribe((alert: Alert) => {
            if (!alert) {
                this.alerts = [];
            } else {
                if (alert.clearPriorAlerts) {
                    this.alerts = [];
                }
                this.alerts.push(alert);
                window.scrollTo(0, 0);
                LoggingService.log('Alert: ', this.alerts);
                if (alert.autoClose) {
                    setTimeout(() => this.removeAlert(alert), 5000);
                }
            }
        });

        this.routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.alerts = this.alerts.filter((alert) => {
                    if (alert.keepAfterRouteChange) {
                        if (alert.hasKeptAfterRouteChange) {
                            // If the alert has already been kept after a route change, remove it
                            return false;
                        } else {
                            // Mark the alert as kept after a route change
                            alert.hasKeptAfterRouteChange = true;
                            return true;
                        }
                    }
                    return false;
                });
            }
        });
    }

    close(alert: Alert) {
        this.alerts.splice(this.alerts.indexOf(alert), 1);
    }

    removeAlert(alert: Alert) {
        this.close(alert);
    }

    // Based on the alert type set the icon class for the alert box
    iconClass(alert: Alert): string | undefined {
        if (alert) {
            const classes = ['bi'];
            const iconTypeClass = {
                [AlertType.success]: 'bi-check-circle',
                [AlertType.danger]: 'bi-exclamation-circle',
                [AlertType.info]: 'bi-info-circle',
                [AlertType.warning]: 'bi-exclamation-triangle',
                [AlertType.primary]: 'bi-info-circle',
            };

            classes.push(iconTypeClass[alert.type]);
            return classes.join(' ');
        }
        return '';
    }

    ngOnDestroy(): void {
        this.alertSubcription.unsubscribe();
        this.routerSubscription.unsubscribe();
    }
}
